import * as React from "react";
import {
    Button,
    FormGroup,
    Grid,
    Switch,
    TextField,
    FormControlLabel
} from "@material-ui/core";
import {API} from "aws-amplify";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {disableAutoRefillRequestDefault, IDisableAutoRefillRequest} from "./request/DisableAutoRefillRequest";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: IDisableAutoRefillRequest
    response: any
}

enum InputField {
    DRUG_ID,
    PERSON_ID,
    PROFILE_ID,
    PRESCRIPTION_ID
}

class DisableAutoRefillSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: disableAutoRefillRequestDefault,
            request: {} as IDisableAutoRefillRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>

                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Drug Id"
                                variant="outlined"
                                value={ this.state.request.drugId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DRUG_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Person Id"
                                variant="outlined"
                                value={ this.state.request.personId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PERSON_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Prescription Id"
                                variant="outlined"
                                value={ this.state.request.prescriptionId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PRESCRIPTION_ID, event) }
                            />
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 6 }
                            label="Disable Auto Refill Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Disable Auto Refill
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <Alert variant="filled" severity="info">
                        Auto refill disabled
                    </Alert>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IDisableAutoRefillRequest = this.state.request;

        switch (field) {
            case InputField.DRUG_ID: {
                updatedRequest.drugId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PERSON_ID: {
                updatedRequest.personId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PROFILE_ID: {
                updatedRequest.profileId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PRESCRIPTION_ID: {
                updatedRequest.prescriptionId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });
        let body: IDisableAutoRefillRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
        } else {
            body = this.state.request;
        }

        const config = {
            body,
            headers: {}
        }

        this.callDisableAutoRefill(config);

        this.setState({ isLoading: false });
    }

    private callDisableAutoRefill(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/auto-refill/disable';

        console.log(config)
        API.post(apiName, path, config).then((disableAutoRefillResponse: any) => {
            console.log(disableAutoRefillResponse);

            this.setState({ response: disableAutoRefillResponse.disabled });
        }).catch((error) => {
            console.log(error);

            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default DisableAutoRefillSection;